//#region Constants
export let TABLE_ACTION = /*#__PURE__*/function (TABLE_ACTION) {
  TABLE_ACTION["DELETED"] = "deleted";
  TABLE_ACTION["CLEARED"] = "cleared";
  TABLE_ACTION["COLLAPSED"] = "collapsed";
  TABLE_ACTION["MERGED"] = "merged";
  TABLE_ACTION["SPLIT"] = "split";
  TABLE_ACTION["COLORED"] = "colored";
  TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
  TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
  TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
  TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
  TABLE_ACTION["CUT"] = "cut";
  TABLE_ACTION["COPIED"] = "copied";
  TABLE_ACTION["ADDED_ROW"] = "addedRow";
  TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
  TABLE_ACTION["DELETED_ROW"] = "deletedRow";
  TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
  TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
  TABLE_ACTION["REPLACED"] = "replaced";
  TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
  TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
  TABLE_ACTION["FIXED"] = "fixed";
  TABLE_ACTION["RESIZED"] = "resized";
  TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
  TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
  TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
  TABLE_ACTION["MOVED_ROW"] = "movedRow";
  TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
  TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
  return TABLE_ACTION;
}({});
export let TABLE_BREAKOUT = /*#__PURE__*/function (TABLE_BREAKOUT) {
  TABLE_BREAKOUT["WIDE"] = "wide";
  TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
  TABLE_BREAKOUT["NORMAL"] = "normal";
  return TABLE_BREAKOUT;
}({});
//#endregion

export let TABLE_OVERFLOW_CHANGE_TRIGGER = /*#__PURE__*/function (TABLE_OVERFLOW_CHANGE_TRIGGER) {
  TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
  TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
  TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
  TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
  TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
  TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
  TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
  TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
  return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
export let TABLE_STATUS = /*#__PURE__*/function (TABLE_STATUS) {
  TABLE_STATUS["SUCCESS"] = "success";
  TABLE_STATUS["CANCELLED"] = "cancelled";
  TABLE_STATUS["INVALID"] = "invalid";
  return TABLE_STATUS;
}({});

//#region Type Helpers

//#endregion

//#region Analytic Event Payloads